module.exports = __webpack_public_path__ + "static/media/more-icon.50910bd8.PNG";